export default "__VITE_ASSET__8d697d39__"